import React, { useEffect, useState } from "react";
import { client } from "@/lib/api";
import { LEAD } from "@/constants/testIds";
import { toast } from "sonner";
import { formatEAT } from "@/lib/design";

const STATUSES = ["new", "contacted", "onboarded", "declined"];

export default function LeadsPage() {
  const [leads, setLeads] = useState([]);
  const load = async () => {
    const r = await client.get("/admin/leads");
    setLeads(r.data.leads || []);
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, contact_status) => {
    await client.put(`/admin/leads/${id}`, { contact_status });
    toast.success("Updated");
    await load();
  };
  const setNotes = async (id, notes) => {
    await client.put(`/admin/leads/${id}`, { notes });
  };

  return (
    <div className="p-8">
      <p className="label-tiny">watu wako</p>
      <h1 className="font-display text-3xl font-bold">curator leads</h1>
      <p className="mt-2 max-w-2xl text-sm text-neutral-600">Every curator handle the pipeline has ever seen — this is the sales-outreach pipeline. Update status and add notes as you contact them.</p>

      <div className="mt-6 overflow-hidden rounded-lg border border-neutral-200 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-left">
            <tr>
              <th className="p-3">Handle</th><th className="p-3"># events</th><th className="p-3">First seen</th><th className="p-3">Last seen</th>
              <th className="p-3">Status</th><th className="p-3">Notes</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} data-testid={LEAD.row(l.id)} className="border-t border-neutral-100 align-top">
                <td className="p-3 font-semibold">@{l.handle}</td>
                <td className="p-3">{l.event_count}</td>
                <td className="p-3 text-neutral-500">{formatEAT(l.first_seen_at)}</td>
                <td className="p-3 text-neutral-500">{formatEAT(l.last_seen_at)}</td>
                <td className="p-3">
                  <select data-testid={LEAD.statusSelect(l.id)} className="rounded-md border border-neutral-300 p-1.5 text-xs" defaultValue={l.contact_status} onChange={(e) => setStatus(l.id, e.target.value)}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="p-3">
                  <input
                    data-testid={LEAD.notesInput(l.id)}
                    className="w-64 rounded-md border border-neutral-300 p-1.5 text-xs"
                    defaultValue={l.notes || ""}
                    onBlur={(e) => setNotes(l.id, e.target.value)}
                    placeholder="Add notes…"
                  />
                </td>
              </tr>
            ))}
            {leads.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-sm text-neutral-500">No leads yet — they accrue automatically as events flow in.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
